import {
  getNoticeName,
  isReady,
  addListenerToNotice,
  createNoticeInstance,
} from './notices-utils';

const $notices = $('[role="notice"]');

$notices.each(function() {
  let $noticeElem = $(this);
  addListenerToNotice($noticeElem, function() {
    let notice = createNoticeInstance($noticeElem);
    notice.show();
  });

  $(document).ready(function () {
    if (isReady($noticeElem)) {
      Utilities.showNoticeByName(getNoticeName($noticeElem));
    }
  });
});
